<template>
<div class="container">

<mt-header :title="title" :fixed="true">
  <mt-button icon="back" slot="left" @click="doback()"></mt-button>
</mt-header>

<div class="form" v-show="!showteam">

<div class="row" v-show="f.isteam==1">
	<hos @select="haha" :hos="f.hos" :isbook="1"></hos>	
</div>

<div class="row" v-show="f.isteam==2">
	<div class="col-3 left" style="letter-spacing:0;">体检分院</div>
	<div class="col-7">
	    <mt-field v-model="f.hos" readonly></mt-field>
	</div>
</div>

<div class="row" v-show="family.length>0&&f.isteam==1">
	<div class="col-3 left">体检人</div>
	<div class="col-7">
		<mt-button @click="show">{{fpeople}}</mt-button>
		<mt-actionsheet :actions="actions" v-model="showaction"></mt-actionsheet>
	</div>
</div>

<div class="row">
	<div class="col-3 left">姓&nbsp;&nbsp;名</div>
	<div class="col-7">
		<mt-field placeholder="请输入姓名" v-model="f.xm" :readonly="f.isteam==2"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">身份证</div>
	<div class="col-7">
		<mt-field placeholder="请输入身份证号码" v-model="f.sfzh" :readonly="f.isteam==2"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">性&nbsp;&nbsp;别</div>
	<div class="col-7" style="padding-top:.7rem;">
		<mt-switch v-model="f.sex" :disabled="f.isteam==2">{{f.sex?"男":"女"}}</mt-switch>
	</div>
</div>

<div class="row" v-show="f.isteam==2||(hadbuy&&hadbuy.length>0)">
	<div class="col-3 left" style="letter-spacing:0;">套餐名称</div>
	<div class="col-7">
	    <mt-button @click="showtc">{{f.tcmc|title}}</mt-button>
		<mt-actionsheet :actions="tcactions" v-model="showtcname"></mt-actionsheet>
	</div>
</div>

<div class="row" v-show="f.isteam==1&&(!hadbuy||hadbuy.length==0)">
	<div class="col-3 left" style="letter-spacing:0;">套餐名称</div>
	<div class="col-7">
	    <mt-button @click="showmore">{{tcbtn|title12}}</mt-button>
		<mt-popup v-model="moretc" :modal="false"><tc :hos="f.hos" :list="tclist" @close="select_tc"></tc></mt-popup>
	</div>
</div>

<div class="row">
	<div class="col-3 left" style="letter-spacing:0;">预约时间</div>
	<div class="col-7">
	    <mt-button @click="gettime">{{f.yysj}}</mt-button>
	</div>
</div>

<mt-popup v-model="showtime" :modal="false" class="time" popup-transition="popup-fade">
	<h3 class="center" @click="hidetime">请选择预约时间</h3>
	<div class="row cal" v-show="showtime&&time1">
		<cal :time="time1" @select="orderTime"></cal>
	</div>
	<div class="row cal" v-show="showtime&&time2">
		<cal :time="time2" @select="orderTime"></cal>
	</div>
	<div class="row center myclose">
		<mt-button type="danger" size="large" @click="hidetime">关 闭</mt-button>
	</div>
</mt-popup>

<div class="row">
	<div class="col-3 left">手机号</div>
	<div class="col-7">
		<mt-field placeholder="请输入手机号码" v-model="f.dh"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left" style="letter-spacing:0;">Email</div>
	<div class="col-7">
		<mt-field placeholder="请输入Email，选填" v-model="f.email"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">QQ</div>
	<div class="col-7">
		<mt-field placeholder="请输入QQ，选填" v-model="f.qq"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">微&nbsp;&nbsp;信</div>
	<div class="col-7">
		<mt-field placeholder="请输入微信号，选填" v-model="f.wx"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">备&nbsp;&nbsp;注</div>
	<div class="col-7">
		<mt-field placeholder="备注，选填" v-model="f.bz"></mt-field>
	</div>
</div>


</div>

<div class="row pd" v-show="!showteam">
	<mt-button type="primary" size="large" :disabled="substatus" @click="sub">确定预约</mt-button>
</div>


<team @select="teamData" v-show="showteam"></team>


</div>
</template>

<style scoped>	
.time{width:100vw;height:100%;overflow: auto;}
.center{color:rgb(0,144,255);margin:.5rem 0;}
.container{background: rgb(251,251,251);}
.pd{padding:.5rem 1rem 2rem;}
.cal{margin-bottom:.5rem;float: left;}
.mint-button--default{height:2rem;margin-top:.4rem;line-height: 2rem; }
.form{padding-top:.5rem;margin-bottom: 0;}
.myclose{width:100%;padding:.5rem 1rem;}
</style>

<script>
import hos from "../../lib/hos.vue";
import tc from "../../lib/tc.vue";
import cal from "../../lib/calendar.vue";
import team from "./team.vue";

export default {
	components:{hos,tc,cal,team},
	data:function(){
		return {
			mydata:mydata,
			title:"个人体检预约",
			hadbuy:"",
			family:"",
			f:{
				hos:"",
				xm:"",
				sfzh:"",
				sex:true,
				dh:"",
				email:"",
				qq:"",
				wx:"",
				bz:"",
				yysj:"请选择预约时间",
				tcmc:"请选择套餐",
				ocode:"",
				gucode:"",
				isteam:1,
				com:"",
				htid:"",
				htmc:"",
				tjid:"",
				internetusertaocan:"",
				wpid:-1,
			},
			showaction:false,
			actions:[],
			showtcname:false,
			tcactions:[],
			moretc:false,
			oldsex:3,
			oldhos:"",
			tclist:[],
			tcbtn:"请选择套餐",
			fpeople:"选择常用体检人",
			time1:"",
			time2:"",
			showtime:false,
			showteam:false,
			substatus:false,

		}
	},
	created:function(){
		if(!fun.islogin()){
			this.$router.push('/login');
		}
		this.init();
	},
	methods:{
		init:function(){
			mydata.userheader=false;
		   var path=this.$route.path;
		   if(path=="/user/team"){
		   	this.title="单位体检预约";
		   	this.f.isteam=2;
		   	this.showteam=true;
		   }else{
		   	this.title="个人体检预约";
		   	var id=this.$route.params.id;
		    this.getdata(id);
		   }
		},
		doback:function(){
          if(!this.showteam&&this.f.isteam==2){
          	this.showteam=true;
          }else{
          	this.$router.go(-1);
          }
		},
		teamData:function(d){
			console.log(d);
			this.showteam=false;
			this.f.hos=d.hos;
			this.f.xm=d.xm;
			this.f.sfzh=d.sfzh;
			this.f.sex=d.xb=="男"?true:false;
			this.f.dh=d.dh1;
			this.f.email=d.email;
			this.f.qq=d.qqh;
			this.f.wx=d.weixinh;
			this.f.tcmc=d.tcmc;
			this.f.isteam=2;
			this.f.com=d.com;
			this.f.htid=d.htid;
			this.f.htmc=d.htmc;
			this.f.tjid=d.tjid;
			this.f.internetusertaocan=d.internetusertaocan;
			this.f.wpid=d.wpid;
		},
		select_tc:function(d){
			console.log(d);
			this.tcbtn=this.f.tcmc=d.name;
			this.f.wpid=d.id;
			this.moretc=false;
		},
		gettime:function(){
		  var _this=this;
		  var data={
			  hos:this.f.hos,
			  htid:this.f.htid
			  };
          if(!data.hos){this.$toast("请选择分院");return false;}

          fun.post(mydata.apiuser+"gettime",data,function(d){
          	console.log(d);
          	if(d.status==1){
          		if(d.info.total==0){_this.$toast("暂无可预约时间");return false;}
          		_this.time1=d.info.now;
          		_this.time2=d.info.next?d.info.next:"";
          		_this.showtime=true;
          	}else{
          		_this.$toast(d.info);
          	}
          })
		},
		orderTime:function(d){
			this.f.yysj=d;
			this.showtime=false;
		},
		hidetime:function(){
			this.showtime=false;
		},
		showmore:function(){
			var _this=this;
			var data={hos:this.f.hos,sex:this.f.sex};
			if(!data.hos.trim()){this.$toast("请选择分院");return false;}
			if(this.oldsex===this.f.sex){this.moretc=true;return false;}
            this.oldsex=this.f.sex;
			fun.post(mydata.apiuser+"tclist",data,function(d){
				//console.log(d);
				if(d.status==1){
					d.info.unshift({id:-1,name:"到院再选套餐",price:"价格未定"});
					_this.tclist=d.info;
					_this.moretc=true;
				}else{
					_this.$toast(d.info);
				}
			})
			
		},
		show:function(){
			var len=this.family.length;
			for(var i=0;i<len;i++){
				var tem=this.family[i];
				tem.name=tem.xm;
				tem.method=this.fname;
				this.actions[i]=tem;
			}
			this.showaction=true;
		},
		showtc:function(){
		   if(this.f.isteam==2){return;}
           var len=this.hadbuy.length;
           for(var i=0;i<len;i++){
           	var item=this.hadbuy[i];
           	var tem=this.newitem(item);
           	tem.method=this.settc;
           	this.tcactions[i]=tem;
           }
           this.showtcname=true;
		},
		newitem:function(item){
            var tem={
               name:item.name,
               ocode:item.ocode,
               gucode:item.gucode,
           	};
           	if(tem.name.length>12){
           		tem.name=tem.name.substr(0,12)+"...";
           	}
           	if(item.attrs>1){tem.name=tem.name+"("+item.attr_value+")";}
           	tem.name=tem.name+"["+item.price/100+"]";
           	return tem;
		},
		settc:function(d){
          console.log(d);
          this.f.tcmc=d.name;
          this.f.ocode=d.ocode;
          this.f.gucode=d.gucode;
		},
		fname:function(d){
			console.log(d);
			this.f.xm=d.xm?d.xm:d.name;
			this.f.sfzh=d.sfzh;
			this.f.sex=d.xb==1?true:false;
			this.f.dh=d.dh1;
			this.fpeople="已选体检人";
		},
		getdata:function(id){
          var data={id:id};
          var _this=this;
          fun.post(mydata.apiuser+"person",data,function(d){
          	console.log(d);
          	if(d.status==1){
          		_this.hadbuy=d.info.hadbuy;
          		_this.family=d.info.family;
          		if(d.info.hadbuy.length==1){
          			_this.settc(_this.newitem(d.info.hadbuy[0]));
				  }
				if(d.info.family.length>0){
					_this.fname(d.info.family[0]);
				 }
          	}else{
          		_this.$toast(d.info);
          	}
          })
		},
		haha:function(d){
			this.f.hos=d;
		},
		sub:function(){
          var _this=this;
          var check=this.check();
          if(check){this.$toast(check);return;}
		  this.substatus=true;
		  if(this.f.internetusertaocan=="True"){
			 fun.post(mydata.api+"Member/set_team_taocan",this.f,function(d){
				 console.log(d)
				 if(d.status==1){
					 _this.sub_order();
				 }else{
					 _this.$toast(d.info);
					 _this.substatus=false;
				 }
			 }) 
		  }else{
			  _this.sub_order();
		  }
		},
		sub_order:function(){
			var _this=this;
			fun.post(mydata.apiuser+"order_sub",this.f,function(d){
				console.log(d);
				_this.substatus=false;
				if(d.status==1){
					_this.$messagebox.alert(d.info).then(function(){
						_this.$router.push("/user/mybook");
					})
				}else{
					_this.$toast(d.info);
				}
			})
		},
		check:function(){
		  if(!this.f.hos){return "请选择分院";}
		  if(!this.f.xm||this.f.xm.match(/\d/)||this.f.xm.length<2){return "请填写正确的姓名";}
		  if(!fun.check_sf(this.f.sfzh)){return "请填写正确的身份证号码";}
		  if(!this.f.tcmc||this.f.tcmc=="请选择套餐"){return "请选择套餐";}
		  if(this.f.yysj=="请选择预约时间"){return "请选择预约时间";}
		  if(!this.f.dh.match(/^1\d{10}$/)){return "请填写正确的手机号码";}
		}
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/user/person.vue